<template>
  <div class="h-full p-8 pb-16 pt-0 w-full overflow-auto">
    <UserProperty
      @dataAvailable="
        data => {
          userData = data || {}
        }
      "
    />
    <div
      class="flex w-full justify-between items-center sticky top-0 pt-8 pb-4 z-[2] bg-[#f4f4f5]"
    >
      <div class="text-4xl title-color">Validation de store</div>
    </div>
    <div class="py-2"></div>
    <div class="py-4"></div>
    <UserProperty
      @dataAvailable="
        data => {
          userData = data
        }
      "
      isComponent
    />
    <div v-if="step == 0" class="flex flex-col min-h-full">
      <div class="text-3xl">Informations de base</div>
      <div class="">
        Les informations d'inscription ne peuvent pas être modifiées moins de 3
        mois après l'approbation de l'inscription
      </div>
      <div class="py-4"></div>
      <FormComponent
        class="w-full grid grid-cols-12"
        :fields="step1FormFields"
        :onFormSubmited="
          data => {
            infoStepFormSubmited(data)
          }
        "
        :loading="false"
      >
        <template #submitButton>
          <button class="hidden" type="submit" ref="submit"></button>
        </template>
      </FormComponent>
      <button
        class="buttonComponent top-6 mt-auto arrow w-full"
        @click="$refs.submit.click()"
      >
        continuer
      </button>
    </div>
    <div v-else-if="step == 1" class="flex flex-col min-h-full">
      <div class="text-3xl">Vérifiez l'entreprise</div>
      <div class="">Téléversez jusqu'à 6 images</div>
      <div class="py-4"></div>
      <div class="grid grid-cols-3 gap-8">
        <div
          v-for="(file, i) in files"
          :key="i"
          class="h-[100px] rounded-xl overflow-hidden bg-slate-200 relative"
        >
          <div
            class="absolute w-8 h-8 flex items-center justify-center top-0 right-0 bg-slate-300"
            @click="removePicture(i)"
          >
            <div>x</div>
          </div>
          <img
            :src="file.url"
            alt=""
            class="w-full h-full object-contain object-center"
          />
        </div>
        <div
          class="h-[100px] rounded-xl overflow-hidden"
          v-show="files.length < 6"
        >
          <FileUploader
            :acceptedFilesTypes="['image/png', 'image/jpeg']"
            v-if="fileUploaderAvailable"
            @onFileChanged="
              (id, name, url) => {
                newFileSelected(id, name, url)
              }
            "
          >
            <div
              class="w-full h-full flex items-center justify-center bg-slate-200"
            >
              <div class="text-6xl">+</div>
            </div>
          </FileUploader>
        </div>
      </div>
      <div class="py-4"></div>
      <div>
        <div>Remarques:</div>
        <div class="py-2"></div>
        <ul class="flex list-disc gap-2 px-8 flex-col">
          <li>Le fichier doit être au format JPEG, JPG ou PNG.</li>
          <li>Chaque fichier doit être moins de 10Mo</li>
          <li>
            Les marges doivent être claires, en couleur ou contenir le nom légal
            de l'entreprise et les informations requises
          </li>
          <li>
            les documents doivent être en cours de validité et ne peuvent pas
            être expirés ou modifiés
          </li>
          <li>
            Type de document suggérer:
            <a href="" class="font-bold">En savoir plus</a>
          </li>
        </ul>
      </div>
      <button
        class="buttonComponent relative top-6 mt-auto arrow w-full"
        @click="finishPicturesSelection"
      >
        continuer
      </button>
    </div>
    <div v-else-if="step == 2" class="flex flex-col min-h-full">
      <div class="text-3xl">Vérifiez votre accès</div>
      <div class="">Vérifiez votre accès à l'entreprise</div>
      <div class="py-4"></div>
      <div class="">
        Nous avons envoyé une otp de confirmation sur votre adresse
        {{ userData.email }}
      </div>
      <div class="py-4"></div>
      <div class="">Veuillez renseiller l'otp reçu</div>
      <div class="py-4"></div>
      <form @submit.prevent="validateOtp">
        <InputComponent
          v-model="otpReceived"
          type="number"
          placeHolder="OTP Reçu"
        />
      </form>
      <div class="py-4"></div>
      <div class="flex justify-center">
        <button
          class="underline text-blue-500"
          :class="{ 'opacity-60 !text-gray-400': !canResendOtp }"
          @click="tryResendOtp"
        >
          Renvoyer le code
        </button>
      </div>

      <button
        class="buttonComponent top-6 mt-auto arrow w-full"
        @click="validateOtp"
      >
        Valider le code
      </button>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import FormComponent from '@/components/utils/FormComponent.vue'
import FileUploader from '@/components/utils/FileUploader.vue'
import InputComponent from '@/components/utils/InputComponent.vue'
import UserProperty from '@/components/user/UserProperty.vue'
import { OtpUtils } from '@/utils/plugins/otpUtils'

export default defineComponent({
  name: 'ProfileContent',
  components: { FormComponent, FileUploader, InputComponent, UserProperty },
  props: {},
  data() {
    return {
      step: 0,
      fileUploaderAvailable: true,
      eventsIds: [],
      files: [],
      step1FormFields: [
        {
          type: 'text',
          propertyName: 'companyName',
          label: "Nom légal de l'entreprise",
          defaultValue: '',
          required: true,
          class: 'col-span-12 !mb-8',
          inputProps: {
            detailText:
              "Saisissez le nom légal de l'entreprise exactement comme il apparait sur les documents commerciaux",
          },
        },
        {
          type: 'select',
          propertyName: 'country',
          label: 'Pays ou région',
          options: this.$Countries.getSignupCountries().sort((ca, cb) => {
            if (ca.countryName > cb.countryName) return 1
            if (ca.countryName < cb.countryName) return -1
            return 0
          }),
          formatOptionInputDisplay(country) {
            return `${country.countryName}`
          },
          formatOptionsDisplay(country) {
            return `<div class="flex text-lg justify-between w-full items-center h-[30px] relative"><span>${
              country.countryName
            }</span><span class="absolute left-[calc(100vw-90px)]">${
              country.countryFlag
            }</span></div>`
          },
          inputProps: {
            selectTitle: 'Séléctionnez un pays',
            useModal: false,
            detailText:
              'Choissisez le pays ou la région exactement comme cela apparait sur les documents commerciaux',
          },
          defaultValue: `Bénin`,
          required: true,
          class: 'col-span-12 locationCountry',
        },
        // {
        //   type: "text",
        //   propertyName: "country",
        //   label: "Pays ou région",
        //   defaultValue: "",
        //   required: true,
        //   class: "col-span-12",
        //   inputProps: {
        //     detailText:
        //       "Choissisez le pays ou la région exactement comme cela apparait sur les documents commerciaux",
        //   },
        // },
        {
          type: 'text',
          propertyName: 'addresss',
          label: 'Adresse',
          defaultValue: '',
          required: true,
          class: 'col-span-12',
          inputProps: {},
        },
        {
          type: 'text',
          propertyName: 'state',
          label: 'Province ou Etat',
          defaultValue: '',
          required: true,
          class: 'col-span-12',
          inputProps: {},
        },
        {
          type: 'text',
          propertyName: 'city',
          label: 'Ville',
          defaultValue: '',
          required: true,
          class: 'col-span-12',
          inputProps: {},
        },
        {
          type: 'text',
          propertyName: 'postalCode',
          label: 'Code postale',
          defaultValue: '',
          required: true,
          class: 'col-span-12',
          inputProps: {},
        },
        {
          type: 'select',
          propertyName: 'countryPrefix',
          options: this.$Countries.get().sort((ca, cb) => {
            if (ca.countryName > cb.countryName) return 1
            if (ca.countryName < cb.countryName) return -1
            return 0
          }),
          formatOptionInputDisplay(country) {
            return `+${country.callingCode}`
          },
          formatOptionsDisplay(country) {
            return `<div class="flex text-lg justify-between w-full items-center h-[30px] relative"><span>${
              country.countryName
            }</span><span class="absolute left-[calc(100vw-200px)] w-[50px] text-right">+${
              country.callingCode
            }</span></div>`
          },
          inputProps: {
            selectTitle: 'Séléctionnez un préfix',
            useModal: false,
            hideSelectedCheck: true,
          },
          label: '',
          defaultValue: `+229`,
          required: true,
          class:
            ' !w-[6rem] relative z-[2] pl-3 locationCountry phonePrefix  [&_.inputContainer]:!bg-transparent [&_.inputContainer]:!border-none [&_.inputContainer]:!text-l [&_.inputContainer]:!absolute [&_.inputContainer]:!pl-3 [&_input]:!p-[0px] countryPrefix',
        },
        {
          type: 'number',
          propertyName: 'phoneNumber',
          label: 'Numéro de télépone',
          defaultValue: '',

          inputProps: {
            allowTrailingZero: true,
            minLenght: 6,
          },
          required: true,
          class:
            'col-span-12 [&_input]:!pl-[7rem] [&_label]:!pl-[6rem] [&_input:focus_~_label]:!pl-[0px]  [&_input:not(.empty)_~_label]:!pl-[0px]',
        },
        {
          type: 'text',
          propertyName: 'commercialLicenceId',
          label: 'Id de licence commerciale',
          defaultValue: '',
          required: true,
          class: 'col-span-12',
          inputProps: {
            detailText:
              "Saisisez l'Id de la licence de l'entreprise exactement comme il apparait sur les documents commerciaus",
          },
        },
        {
          type: 'text',
          propertyName: 'website',
          label: 'Site Web (facultatif)',
          defaultValue: '',
          class: 'col-span-12',
          inputProps: {},
          validate() {
            return ''
          },
        },
      ],
      infoStepFormData: {},
      newFile: '',
      userData: {},
      otpReceived: '',
      displayMessage: '',
      canResendOtp: false,
      otpResendRefreshTimeout: 0,
      otpResetTime: 0,
    }
  },
  mounted() {
    const id = this.$Events.handleEvent(
      'account_validation_info_saved',
      this.accountInfoSaved,
    )
    const id2 = this.$Events.handleEvent(
      'account_validation_info_saving_failed',
      this.accountInfoSavingFailed,
    )
    this.eventsIds.push(id)
    this.eventsIds.push(id2)
  },
  beforeUnmount() {
    this.eventsIds.forEach(this.$Events.removeHandler)
  },
  methods: {
    infoStepFormSubmited(inputData) {
      const countryPrefix =
        inputData.countryPrefix || this.$Countries.find('BJ')
      const phoneNumber = `${countryPrefix.callingCode}${inputData.phoneNumber}`
      const data = JSON.parse(JSON.stringify(inputData))
      const locationCountry = data.locationCountry || this.$Countries.find('BJ')
      data.countryCode = locationCountry?.countryCode || 'BJ'
      data.phoneNumber = phoneNumber
      delete data.countryPrefix
      this.infoStepFormData = data
      console.log(this.infoStepFormData)
      this.step++
    },
    newFileSelected(id, name, url) {
      console.log(id, name, url)
      this.files.push({ url: url })
      this.fileUploaderAvailable = false
      setTimeout(() => {
        this.fileUploaderAvailable = true
      }, 500)
    },
    removePicture(index) {
      this.files = this.files.filter((file, i) => i !== index)
      this.$forceUpdate()
    },
    async finishPicturesSelection() {
      if (this.files.length < 2) {
        this.$Events.dispatchEvent('toast_notification', {
          body: 'Veuillez téléverser au moins deux documents de votre entreprise',
        })
        return
      }
      this.$Events.dispatchEvent('start_loading')
      const { sent } = await OtpUtils.sendOtp(
        this.userData.email,
        this.userData.firstName,
      )
      this.$Events.dispatchEvent('finish_loading')
      if (!sent) {
        this.$Events.dispatchEvent('toast_notification', {
          title: 'Veuillez réessayer',
          body: "Echec d'envoie de code otp pour vérifier votre compte. Veuillez réessayer",
        })
        return
      }
      this.refreshOtpResendDelay()
      this.step++
    },
    refreshOtpResendDelay() {
      this.canResendOtp = false
      clearTimeout(this.otpResendRefreshTimeout)
      const { delayInMs, timestamp } = OtpUtils.getOtpDelay()
      this.otpResetTime = timestamp
      if (delayInMs <= 0) {
        this.canResendOtp = true
        return
      }
      this.otpResendRefreshTimeout = setTimeout(() => {
        this.canResendOtp = true
      }, delayInMs)
    },
    tryResendOtp() {
      this.refreshOtpResendDelay()
      if (!this.canResendOtp) {
        const { delayInMs, timestamp } = OtpUtils.getOtpDelay()
        const delayMin = Math.ceil(delayInMs / 1000 / 60)
        this.$Events.dispatchEvent('toast_notification', {
          body: `Veuillez patienter ${delayMin} minute${
            delayMin > 1 ? 's' : ''
          } avant de demander un renvoie du code otp`,
        })
        return
      }
      this.resetOtp()
    },
    async resetOtp() {
      this.$Events.dispatchEvent('start_loading')
      const response = await OtpUtils.resendOtp(
        this.userData.email,
        this.userData.firstName,
      )
      this.$Events.dispatchEvent('finish_loading')
      if (!response.sent) {
        this.$Events.dispatchEvent('toast_notification', {
          body: "Echec d'envoie du OTP, veuillez réessayer",
        })
        return
      }
      this.$Events.dispatchEvent('toast_notification', {
        body: 'Otp Renvoyé',
      })
      this.refreshOtpResendDelay()
    },
    async validateOtp() {
      const res = await OtpUtils.confirmOtp(
        this.otpReceived,
        this.userData.email,
      )
      const { confirmed, expired } = res
      if (expired) {
        this.$Events.dispatchEvent('toast_notification', {
          title: 'Expiré',
          body: 'Veuillez demander un nouveau code Otp',
        })
        return
      }
      if (!confirmed) {
        this.$Events.dispatchEvent('toast_notification', {
          title: 'Incorrect',
          body: 'Le code entré est incorrect', //+ JSON.stringify(res, null, 2),
        })
        return
      }
      this.$Events.dispatchEvent('account_validation_info_available', {
        ...this.infoStepFormData,
        pictures: this.files,
      })
      this.$Events.dispatchEvent('toast_notification', {
        body: 'Code correct. nous enrégistrons vos informations',
      })
      this.$Events.dispatchEvent('start_loading')
    },
    async accountInfoSaved() {
      await new Promise(r => setTimeout(r, 1000))
      this.$Events.dispatchEvent('finish_loading')
      this.$Events.dispatchEvent('toast_notification', {
        body: 'Informations Sauvegardé, Nous allons valider votre compte le plus tot',
      })
      this.$router.push('/')
      // this.$Events.dispatchEvent('show_account_activation')
    },
    accountInfoSavingFailed() {
      this.$Events.dispatchEvent('finish_loading')
      this.$Events.dispatchEvent('toast_notification', {
        type: 'warning',
        body: "Nous n'avons pas pu enrégistrer vos données, veuillez réessayer.",
      })
    },
  },
  watch: {},
})
</script>
